import { request } from "./http";

export interface PushSend {
  id: string;
  user_id: string | null;
  channel: string;
  title: string;
  body: string;
  status: string;
  note: string | null;
  sent_at: string | null;
}

export interface TaxDocument {
  id: string;
  user_id: string | null;
  kind: string;
  tax_year: number;
  jurisdiction: string | null;
  generated_at: string | null;
}

export interface PendingChange {
  id: string;
  user_id: string | null;
  target_table: string;
  target_id: string | null;
  field: string;
  old_value: string | null;
  new_value: string | null;
  applies_at: string | null;
  applied_at: string | null;
  cancelled_at: string | null;
  cancel_reason: string | null;
  requested_at: string | null;
}

export interface SystemStatus {
  status: string;
  checked_at: string;
  service_up: boolean;
  db: boolean;
  redis: boolean;
  lp_status: Record<string, unknown>;
  daemons: Record<string, boolean>;
}

export const opsAdmin = {
  pushSends: () => request<PushSend[]>("/api/v1/admin/push/sends"),
  taxDocuments: () => request<TaxDocument[]>("/api/v1/admin/tax-documents"),
  pendingChanges: (pendingOnly = true) =>
    request<PendingChange[]>(`/api/v1/admin/pending-changes?pending_only=${pendingOnly}`),
  cancelPendingChange: (id: string, cancel_reason?: string) =>
    request<{ id: string; cancelled: boolean }>(`/api/v1/admin/pending-changes/${id}/cancel`, {
      body: { cancel_reason },
    }),
  status: () => request<SystemStatus>("/api/v1/status"),
};
